import React from 'react';

import './require-feature.scss';

/**
 * Shown when a store hits a plan limit (Feature 1: monthly listings). Tells
 * the user what happened and when the allowance resets. No in-app upgrade
 * request (Alex, 2026-10-28) — the limit is explained, not sold.
 */
export function LimitReachedModal({ title, body, resetsAt, onClose }) {
  const resetLine = resetsAt
    ? new Date(resetsAt).toLocaleDateString('en-GB', { day: '2-digit', month: 'long', year: 'numeric' })
    : null;

  return (
    <div className="rc-limit-modal" role="dialog" aria-modal="true" aria-label={title}>
      <div className="rc-limit-modal__backdrop" onClick={onClose} />
      <div className="rc-limit-modal__card">
        <div className="rc-locked-feature__icon" aria-hidden="true">
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="8.5" stroke="currentColor" strokeWidth="1.6" />
            <path d="M12 7.5V12L15 14" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
          </svg>
        </div>
        <h3>{title}</h3>
        <p>
          {body}
          {resetLine && <> Your allowance resets on <strong>{resetLine}</strong>.</>}
        </p>

        <div className="rc-limit-modal__actions">
          <button type="button" className="rc-btn rc-btn--small" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
}

export default LimitReachedModal;
